module.exports = __webpack_public_path__ + "img/nrn1-b1.236f07ac.gif";